module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAfklEQVR42u3aoRWAQAxEwa2R1iiLnlg6OMShyIhv815GRSRtM7kAAAAAAAAAAAAAADAcIMfZne4ry3bnfx0AAAAAAAAAAAAAAAAAAAAAoHlb4G8BAAAAAAAAABxCAAAAAAAAAAAAAAAAAAAAwGQAn6IAAAAAAAAAAAAAAIzqAXmaF3lp0QfZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/country/sv-SE.png
// module id = soT5
// module chunks = 1